import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LoginService } from '../login/login.service';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from '@auth0/auth0-angular';
import { MyPermissionService } from '../../services/my-permission.service';
import { SessionTimeoutService } from '../../services/session-timeout.service';
declare var $: any;
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [ ConfirmationService ]
})

export class HeaderComponent implements OnInit {
    showSpinner = false;
    username:any;
    developmentTitle = environment.DEVELOPMENTTITLE;
    impersonating = false;
    loggedInUser: any = '';
    employeesList: any[] = [];
    canImpersonate = false;
    isStaging = environment.DEVELOPMENTTITLE === '' ? false : true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public loginService: LoginService,
        private confirmationService: ConfirmationService,
        public auth: AuthService,
        private myPermissionService: MyPermissionService,
        private sessionTimeout: SessionTimeoutService,
    ) { }

    get canAddUniversalNote(): boolean {
        return this.myPermissionService.isUrlAllowed('universal-note');
    }

    ngOnInit(): void {
        $(document).on('click', '.sidebar-toggle', function() {
            $("body").toggleClass("sidebar-open");
        });
      
        $(document).on('click', ".sidebar-toggle", function() {
            $("body").toggleClass("sidebar-close");
        });
        
        this.loggedInUser = (window as any).loggedInUser || '';
        this.username = this.loggedInUser.firstname + ' ' + this.loggedInUser.lastname;
        
        // this.loginService.loggedUserData().subscribe(data => {
        //     this.showSpinner = false;
        //     this.username = data.firstname + ' ' + data.lastname;
        //     //-------------------Updating local storage with user data to sync in-case impersonated-------------------
        //     localStorage.setItem('loginId', data.id);
        //     localStorage.setItem('type', data.type);
        //     localStorage.setItem('role', data.role);
        //     localStorage.setItem('defaultLandingPage', data.defaultLandingPage);
        //     (window as any).loggedInUser = data;

        // }, error => {
        //     this.showSpinner = false;
        //     // on error log out
        //     localStorage.clear();
        //     this.auth.logout({ logoutParams: { returnTo: document.location.origin }} as any);
        // });

        this.loginService.userLoggedOut.subscribe( () => {
            console.log('came to log out subscribe')
            window.location.href = "/login";
        });

        const impersonateValue = localStorage.getItem('impersonate');
        this.impersonating = impersonateValue !== null && impersonateValue.length > 1 ? true : false;

        this.canImpersonate = this.loggedInUser?.preferences?.includes('impersonatepermissions');

        if(this.impersonating || (this.canImpersonate && this.isStaging)) {
            this.getImpersonateEmployeeList();
        }
    }

    getImpersonateEmployeeList() {
        this.loginService.getImpersonateEmployeeList().subscribe( (response: any) => {
            this.employeesList = response.employees;
        });
    }
    impersonate(email: any) {
        localStorage.setItem('impersonate', email);
        window.location.reload();
    }

    clearImpersonate() {
        localStorage.removeItem('impersonate');
        this.impersonating = false;
        window.location.reload();
    }

    logout() {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to logout?',
            header: 'Logout',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.showSpinner = true;
                // Same path as auto-timeout: stop tracking and close backend login report.
                this.sessionTimeout.performLogout(this.loginService, this.auth);
            }
        });
    }
}
